__turbopack_context__.v({
  "agentCard": "WhatsAppSoporteModal-module__nsIsKG__agentCard",
  "agentInfo": "WhatsAppSoporteModal-module__nsIsKG__agentInfo",
  "backdrop": "WhatsAppSoporteModal-module__nsIsKG__backdrop",
  "closeBtn": "WhatsAppSoporteModal-module__nsIsKG__closeBtn",
  "copyNumberBtn": "WhatsAppSoporteModal-module__nsIsKG__copyNumberBtn",
  "disclaimer": "WhatsAppSoporteModal-module__nsIsKG__disclaimer",
  "fadeIn": "WhatsAppSoporteModal-module__nsIsKG__fadeIn",
  "header": "WhatsAppSoporteModal-module__nsIsKG__header",
  "headerLeft": "WhatsAppSoporteModal-module__nsIsKG__headerLeft",
  "iconBadge": "WhatsAppSoporteModal-module__nsIsKG__iconBadge",
  "messageArea": "WhatsAppSoporteModal-module__nsIsKG__messageArea",
  "messageLabel": "WhatsAppSoporteModal-module__nsIsKG__messageLabel",
  "messageSection": "WhatsAppSoporteModal-module__nsIsKG__messageSection",
  "modalCard": "WhatsAppSoporteModal-module__nsIsKG__modalCard",
  "phoneNumber": "WhatsAppSoporteModal-module__nsIsKG__phoneNumber",
  "startChatBtn": "WhatsAppSoporteModal-module__nsIsKG__startChatBtn",
  "statusDot": "WhatsAppSoporteModal-module__nsIsKG__statusDot",
  "statusRow": "WhatsAppSoporteModal-module__nsIsKG__statusRow",
  "subtitle": "WhatsAppSoporteModal-module__nsIsKG__subtitle",
  "title": "WhatsAppSoporteModal-module__nsIsKG__title",
  "zoomIn": "WhatsAppSoporteModal-module__nsIsKG__zoomIn",
});
